import { render, staticRenderFns } from "./vocabularyTestReport.vue?vue&type=template&id=33af948d&scoped=true"
import script from "./vocabularyTestReport.vue?vue&type=script&lang=js"
export * from "./vocabularyTestReport.vue?vue&type=script&lang=js"
import style0 from "./vocabularyTestReport.vue?vue&type=style&index=0&id=33af948d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33af948d",
  null
  
)

export default component.exports